import { createSelector } from '@reduxjs/toolkit';

import { featureFlags } from '@modules/featureFlags/utils/featureFlags';
import { organizationGuidSel } from '@shared/duck/selectors/general.selectors';

/**
 * Enables the view more button and related screens for advancement details
 * like merit badges, ranks, etc. for Beta Units
 */
export const SBL_5746_betaUnitsSel = createSelector(
  organizationGuidSel,
  currentOrgGuid => {
    const flag = featureFlags.getFlag(
      'SBL_5746_ENABLE_ADV_BETA_UNITS',
    ) as string;
    const unitGuids = new Set(flag?.split(','));
    if (unitGuids.size === 0) return false;
    const show = unitGuids.has(currentOrgGuid);
    return show;
  },
);

/**
 * Council file import. The boolean flag turns it on everywhere; while it is off
 * the units env var soft-releases it to a comma separated list of org guids.
 */
export const SBL_6013_importCouncilFileSel = createSelector(
  organizationGuidSel,
  currentOrgGuid => {
    if (featureFlags.getFlag('SBL_6013_IMPORT_COUNCIL_FILE')) return true;

    const betaUnits = featureFlags.getFlag(
      'SBL_6013_IMPORT_COUNCIL_FILE_UNITS',
    ) as string;
    if (!betaUnits) return false;

    return new Set(betaUnits.split(',')).has(currentOrgGuid);
  },
);

export const SBL_4143_showMessagingSel = createSelector(() => {
  const flagEnabled = featureFlags.getFlag('SBL_4143_SHOW_MESSAGING');
  if (flagEnabled) return true;

  return false;
});
